import { render, staticRenderFns } from "./CommonQuestionsPricingList.vue?vue&type=template&id=68811726&scoped=true&"
import script from "./CommonQuestionsPricingList.vue?vue&type=script&lang=ts&"
export * from "./CommonQuestionsPricingList.vue?vue&type=script&lang=ts&"
import style0 from "./CommonQuestionsPricingList.vue?vue&type=style&index=0&id=68811726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68811726",
  null
  
)

/* custom blocks */
import block0 from "./CommonQuestionsPricingList.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5Ccommon%5CCommonQuestionsPricingList.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
